module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2c89c3945bfcd3516eb719dd9901e3b3.png";